import { Button, notification } from 'antd';
import React, { useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import paymentService from '../../../services/payment/payment.service';
import ticketService from '../../../services/ticketing/ticket.service';
import { set_purchase_error } from '../../../actions/purchase_error.action';
import globalHelper from '../../../helpers/functions/global.helper';
import moment from 'moment';
import { useHistory } from 'react-router';

const PurchaseButton = ({park, is_checkout, final_price, payment_method = 'FIUU'}) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const purchaseRedux = useSelector(state => state.purchase);
    const ticketRedux = useSelector(state => state.ticket);
    const [state, setState] = useState({
        save_loading : false,
    });

    const is_no_ticket_purchased = !(purchaseRedux?.ticket_users?.length > 0 || purchaseRedux?.add_ons?.length > 0);
    const is_no_remaining_capacity = !(!ticketRedux?.is_capacity || (ticketRedux?.is_capacity && ticketRedux?.remaining_capacity > 0));
    // disabled button either is no ticket selected or no remaining capacity
    const is_disabled = (is_no_ticket_purchased || is_no_remaining_capacity);

    const purchaseTicket = async () => {
        setState(state => ({ ...state, save_loading: true }));
        const { 
            visit_date, 
            ticket_users, 
            ticket_type_id, 
            email, 
            park_id, 
            name, 
            add_ons,
            promotion_code, 
            liability_waiver_checked, 
            preference_id, 
            open_date = false,
        } = purchaseRedux ?? {};
        const { special_link } = ticketRedux;

        // ✅ Check MOQ (minimum order quantity) for add-ons
        const moq_violation = add_ons?.find(x => x.minimum_order > 0 && x.quantity < x.minimum_order);
        if (moq_violation) {
            notification.warning({
                message: 'Minimum Order Not Met',
                description: `"${moq_violation.name}" requires a minimum of ${moq_violation.minimum_order} (currently ${moq_violation.quantity}).`,
            });
            setState(state => ({ ...state, save_loading: false }));
            return;
        }

        // ✅ Double-check cut-off rule at checkout
        const is_schoolbreak = process.env.REACT_APP_EVENT_CODE === 'SCHOOLBREAK';
        const visitDay = moment(visit_date, "DD/MM/YYYY"); // specify format

        if (!is_schoolbreak && park?.ticket_cut_off_time && visitDay.isValid()) {
            const now = moment(); // client local time
            const todayCutoff = moment(`${now.format("YYYY-MM-DD")} ${park.ticket_cut_off_time}`, "YYYY-MM-DD HH:mm:ss");

            // Only enforce cutoff if visit_date is today
            if (visitDay.isSame(now, "day") && now.isAfter(todayCutoff)) {
                notification.warning({
                    message: "Cut-off time reached",
                    description: "You can no longer purchase tickets for today.",
                });
                setState((state) => ({ ...state, save_loading: false }));
                return; // stop purchase flow
            }
        }


        const purchaseTicketResponse = await ticketService.purchaseTicket({
            visit_date : globalHelper.parseDate(visit_date),
            ticket_users,
            ticket_type_id,
            email,
            park_id,
            name,
            add_ons,
            promotion_code : promotion_code?.promo_code,
            special_link_id : special_link?.special_link_id,
            liability_waiver_checked, preference_id,
            final_price, // this is to check whether calculation from front end is same with calculation with backend
            open_date, // checking for open date ticket purchase
            ...(is_schoolbreak && { bypass_cutoff : true }),
        }).catch(err => {
            setState(state => ({...state, save_loading : false}));
        }).then(async (ticketResponse) => {
            // const ticket_id = (ticketResponse?.ticket?.ticket_id);
            const { ticket } = ticketResponse;
            const ticket_id = ticket?.ticket_id;
            const running_number = ticket?.running_number;

            //if there is error
            if(ticketResponse?.error){
                const error = ticketResponse?.error[0];
                const { message, type } = error ?? {};
                notification.warning({
                    message : 'Oops',
                    description : message,
                });
                setState(state => ({...state, save_loading : false}));
                //scroll to email
                dispatch(set_purchase_error({
                    [type] : true,
                }))
            }else{
                if(is_checkout){
                    // Generate payment link with selected payment method
                    const paymentLinkResponse = await paymentService.generatePaymentLink(
                        park?.park_code, 
                        {
                            ticket_id,
                            payment_method: payment_method // Pass payment method to backend
                        }
                    ).catch(err =>{
                        notification.error({
                            message: 'Payment Error',
                            description: 'Failed to generate payment link. Please try again.',
                        });
                        setState(state => ({...state, save_loading : false}));
                    });
    
                    //if success, redirect to payment link
                    if(paymentLinkResponse?.url){
                        setTimeout(() => {
                            window.location.href = paymentLinkResponse?.url;
                        }, 100);
                    } else {
                        setState(state => ({...state, save_loading : false}));
                    }
                }else{
                    //go to review page
                    history.push(`/purchase/review/${running_number}`);
                }
                setState(state => ({...state, save_loading : false}));
            }
        });
    }
    return (
        <>
            <Button
            onClick={purchaseTicket}
            size='large'
            type="primary"
            style={{width:'100%', border:'none'}}
            disabled={is_disabled}
            loading={state?.save_loading}
            >
                <span style={{color: "var(--main-text-color)" , fontWeight:500}}>{is_checkout ? 'Check Out' : 'Review Order'}</span>
            </Button>
        </>
    );
}

export default PurchaseButton;